import dayjs from "dayjs";
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);

export const exhibitionPage = () => {
  if (document.body.classList.contains("page_exhibition")) {

    const shopCalendarWraps = document.querySelectorAll(".shop-schedule");

    shopCalendarWraps.forEach((shopCalendarWrap) => {
      const observer = new MutationObserver(() => {
        const captionText = shopCalendarWrap.querySelector(".eo-calendar caption").innerHTML;
        const now = dayjs(captionText.trim(), "M月 YYYY");
        // 監視対象が変更されたら、月を書き換え
        shopCalendarWrap.querySelector(".shop-current-month").innerHTML = now.format("YYYY年MM月");
      });

      /** 監視対象の要素オブジェクト */
      const elem = shopCalendarWrap.querySelector(".eo-widget-cal-wrap");

      /** 監視時のオプション */
      const config = {
        attributes: true,
        childList: true,
        characterData: true,
      };

      /** 要素の変化監視をスタート */
      observer.observe(elem, config);
    });
  }
};
